import './App.css';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
  Navigate
} from "react-router-dom";
import Dashboard from './components/pages/dashboard/dashboard';
import CDR from './components/pages/cdr/cdr';
import Login from './components/pages/login/login';
import { useDispatch, useSelector } from 'react-redux';
import Loader from './components/loader';
import { useEffect } from 'react';
import { setConfig, setCurrentUser, setUserId } from './context/sessionSlice';
import { CurrentCDR } from "./components/pages/cdr/Current/CurrentCDR";
import { HistoricalCDR } from "./components/pages/cdr/Historical/HistoricalCDR";
import Logout from './components/pages/logout/logout';
import useAutoLogout from './autoLogout';
import HourlyCDR from './components/pages/cdr/Hourly/HourlyCDR';
import DownloadReports from "./components/pages/downloadReports/downloadReports";
// import Test from './components/test/test';


const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/dashboard",
        element: <Dashboard />
      },
      {
        path: '/cdr',
        element: <CDR />,
        children: [
          {
            path: "current",
            element: <CurrentCDR />
          },
          {
            path: "historical",
            element: <HistoricalCDR />
          },
          {
            path: "hourly",
            element: <HourlyCDR />
          },
          {
            path: "",
            element: <CurrentCDR />
          }
        ]
      },
      {
        path: '/downloadReports',
        element: <DownloadReports/>
      }
    ]
  },
  {
    path: "/login",
    element: <Login />
  },
  {
    path: "/logout",
    element: <Logout />
  }
  // {
  //   path: "/test",
  //   element: <Test />
  // }
], {
  basename: '/SpioLabDashboard'
});

function getBaseUrl() {
  if (process.env.NODE_ENV === 'development') {
    return '.';
  }

  // Assuming you have "homepage": "http://domain.com/Dashboard/" in your package.json
  const homepage = process.env.PUBLIC_URL || '';
  return homepage;
}


function App() {

  let dispatch = useDispatch();

  let config = useSelector(state => state.session.config);

  useEffect(() => {
    fetch(`${getBaseUrl()}/config.json`)
      .then(response => response.json())
      .then(data => dispatch(setConfig(data)))
      .catch(error => console.log(error));
  }, []);


  useEffect(() => {
    let userData = sessionStorage.getItem('userData');
    if (userData) {
      try {
        userData = JSON.parse(userData);
        if (userData && userData.username) {
          dispatch(setCurrentUser(userData.username));
          dispatch(setUserId(userData.userId));
        }
      } catch (e) {

      }
    }
  }, []);


  if (!config) {
    return <></>
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className="App">
        <RouterProvider router={router} />
        <Loader />
      </div>
    </LocalizationProvider>
  );
}

export default App;


function Root() {

  let currentUser = useSelector(state => state.session.currentUser);
  let isActive = useAutoLogout(15 * 60 * 1000);

  if (!currentUser) {
    return <Navigate to='/login' />
  }

  if (!isActive) {
    return <Navigate to='/logout' />
  }

  return <>
    <Outlet />
  </>
}

function ErrorPage() {
  return (<div style={{ marginTop: '20px', textAlign: 'center' }}>
    Error
  </div>)
}
